"use strict";

var _lodash = require("lodash");
var _underscore = require("underscore");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Utils
/**
 * This controller handle the current module CTAs
 */
var CallToActions = /*#__PURE__*/function () {
  CallToActions.$inject = ["$route", "$routeParams", "blueprintService"];
  /* @ngInject */
  function CallToActions($route, $routeParams, blueprintService) {
    _classCallCheck(this, CallToActions);
    this.$route = $route;
    this.$routeParams = $routeParams;
    this.blueprintService = blueprintService;
  }

  /**
   * Called whenever one-way bindings are updated.
   *
   * @param {Object} changes a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }
   */
  _createClass(CallToActions, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this = this;
      if ((0, _underscore.isEmpty)(changes.controller.currentValue)) {
        return;
      }
      var ctrl = changes.controller.currentValue;
      var eventId = this.$routeParams.eventId;
      this.ctas = (0, _underscore.chain)((0, _lodash.get)(ctrl, 'routeOptions.callToActions') || []).map(function (cta) {
        var createItemFpType = cta.createItemFpType,
          controllerKey = cta.controllerKey,
          label = cta.label;
        var currentRouteDescriptor = (0, _lodash.get)(_this.$route, 'current.$$route') || {};
        var currentRouteBlueprintMetadata = currentRouteDescriptor.blueprintMetadata || {};
        var moduleKey = currentRouteBlueprintMetadata.moduleKey;

        // find generic controller managing this type

        var navItems = _this.blueprintService.getControllerHeadings(moduleKey);
        var navItem;

        // the recommended way
        if (controllerKey) {
          // find right crud controller
          navItem = navItems.find(function (item) {
            return item.ctrlKey === controllerKey;
          });
        }

        // backward compatible way
        if (!navItem && createItemFpType) {
          // find right crud controller
          navItem = navItems.find(function (item) {
            return item.controller === 'GenericNewItemCtrl' && (0, _lodash.get)(item, 'routeOptions.modelFpType') === createItemFpType;
          });
        }

        // find a "create" controller
        if (!navItem) {
          navItem = navItems.find(function (item) {
            return item.ctrlKey === 'create';
          });
        }
        if (navItem && navItem.route && label) {
          return {
            link: navItem.route.replace(':eventId', eventId),
            label: label
          };
        } else {
          console.error('Defined an invalid call to action: ', cta);
        }
      }).compact().value();
    }
  }]);
  return CallToActions;
}();
module.exports = angular.module('backstage.components.common.call-to-actions', []).component('bsCallToActions', {
  templateUrl: '/src/angular/components/common/call-to-actions/call-to-actions.html',
  bindings: {
    controller: '<'
  },
  controller: CallToActions
}).name;